/**
 * @copyright © Paramount Streaming
 * @description Pause Ad Provider enum — identifies the vendor/service used to fetch pause ads.
 */
export enum PauseAdProvider {
	/**
	 * @description Google Ad Manager (GAM) — VAST XML
	 */
	GAM = 'GAM',
	/**
	 * @description FreeWheel — VAST XML (production default for Paramount+ / CBS.com)
	 */
	FREEWHEEL = 'FREEWHEEL',
	/**
	 * @description Pluto TV Ad Image Service — JSON-based API
	 */
	AD_IMAGE_SERVICE = 'AD_IMAGE_SERVICE'
}